import { render, staticRenderFns } from "./BuyInvoiceList.vue?vue&type=template&id=c5bf7b16"
import script from "./BuyInvoiceList.vue?vue&type=script&lang=js"
export * from "./BuyInvoiceList.vue?vue&type=script&lang=js"
import style0 from "./BuyInvoiceList.vue?vue&type=style&index=0&id=c5bf7b16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports